import React, { useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../auth/msalConfig';
import { FiLogIn } from 'react-icons/fi';

const LoginPage: React.FC = () => {
  const { instance } = useMsal();

  const handleLogin = useCallback(() => {
    instance.loginRedirect(loginRequest);
  }, [instance]);

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">AK</div>
        <h1 className="login-title">AmazonKrosno</h1>
        <p className="login-subtitle">Amazon Vendor & Seller Hub</p>
        <button className="login-btn" onClick={handleLogin}>
          <FiLogIn size={18} />
          Zaloguj sie przez Microsoft
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
